import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportesService {
  baserApiUrl: string = environment.baseApi;
  constructor(public http: HttpClient) {}

  reporteGestiones(data: any = {}) {
    return this.http.post(`${this.baserApiUrl}reporteExcel/gestiones`, data);
  }

  reporteTelefonos(data: any = {}) {
    return this.http.post(`${this.baserApiUrl}reporteExcel/telefonos`, data);
  }

  reporteCuentas(data: any = {}) {
    return this.http.post(`${this.baserApiUrl}reporteExcel/cuentas`, data);
  }

  reporteClientes(data: any = {}) {
    return this.http.post(`${this.baserApiUrl}reporteExcel/clientes`, data);
  }

  reporteAcuerdosPagoCuotas(data: any = {}) {
    return this.http.post(
      `${this.baserApiUrl}reporteExcel/acuerdos-pago`,
      data
    );
  }

  reporteAcuerdosPagoTotales(data: any = {}) {
    return this.http.post(
      `${this.baserApiUrl}reporteExcel/acuerdos-pago-totales`,
      data
    );
  }

  reporteCuentasExtinguidas(data: any = {}) {
    return this.http.post(
      `${this.baserApiUrl}reporteExcel/cuentas-extinguidas`,
      data
    );
  }
}
